import {
  createContext,
  useContext,
  useState,
  useLayoutEffect,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";

const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [isRestoringScroll, setIsRestoringScroll] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  // Use useLayoutEffect to prevent FOUC - runs synchronously before paint
  useLayoutEffect(() => {
    // Only reset on actual path changes, not on mount
    if (prevPathRef.current !== location.pathname) {
      prevPathRef.current = location.pathname;
      setScrollPosition(0);
      setScrollDirection(null);
      setIsRestoringScroll(false);
      setShowHeader(true);
    }
  }, [location.pathname]);

  return (
    <ScrollContext.Provider
      value={{
        scrollPosition,
        setScrollPosition,
        scrollDirection,
        setScrollDirection,
        isRestoringScroll,
        setIsRestoringScroll,
        showHeader,
        setShowHeader,
      }}
    >
      {children}
    </ScrollContext.Provider>
  );
};

export const useScroll = () => useContext(ScrollContext);
